import React, { useEffect, useRef } from 'react';
import { LogoutOutlined, EmojiObjects, EmojiObjectsOutlined } from '@mui/icons-material';
import { actions } from '../reducers';
import { logout } from '../Users/uUtils';
import './Menu.css';

type User = {
  id: number,
  name: string,
  token: string,
};

type MenuProps = {
  onLine: boolean,
  user: User,
  isActive: boolean,
  deleted: boolean,
  localDB: IDBDatabase | null,
  dispatchSetUser: React.Dispatch<{ type: string, payload: User | null | undefined }>
  dispatchDeleted: React.Dispatch<{ type: string; payload: boolean; }>
  dispatchMenu: React.Dispatch<{ type: string; payload: boolean; }>
}

export function Menu({ onLine, user, isActive, deleted, localDB, dispatchSetUser, dispatchDeleted, dispatchMenu }: MenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);
  
  const handleClose = () => {
    dispatchMenu(actions.toggle());
  };

  // Обработчик клика вне меню
  useEffect(() => {
    if (!isActive) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      
      if (menuRef.current && !menuRef.current.contains(target)) {
        handleClose();
      }
    };

    // Небольшая задержка, чтобы не закрыть меню при открытии
    const timer = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isActive]);

  if (!isActive) return null;

  const handleLogout = () => {
    if (onLine === false) return;
    handleClose();
    logout(dispatchSetUser, localDB);
  };

  const deletedElement = deleted
    ? (
      <div>
        <button
          className='show-deleted-button'
          onClick={() => {
            dispatchDeleted(actions.toggle());
            handleClose();
          }}>
          <EmojiObjectsOutlined />
          <span>Show active notes</span>
        </button>
      </div>
    ) : (
      <div>
        <button
          className='show-deleted-button'
          onClick={() => {
            dispatchDeleted(actions.toggle());
            handleClose();
          }}>
          <EmojiObjects />
          <span>Show deleted notes</span>
        </button>
      </div>
    );

  return (
    <div className='menu-block' ref={menuRef}>
      <div>{user.name}</div>
      <div>
        <button className='logout-button' onClick={handleLogout}>
          <LogoutOutlined />
          <span>Log out current user</span>
        </button>
      </div>
      {deletedElement}
    </div>
  );
}